import * as React from 'react';
import { STATIC_STORAGE_URL } from '@nexxt/common/constants';

/**
 * Source: [Codepen](https://codepen.io/cojdev/pen/jZErme)
 *
 * SVG Arrows
 *
 * @param props
 *      @property type: "down" | "up" | "right" | "left"
 */

const Icons: React.SFC<{
    type:
        | 'arrow-down'
        | 'arrow-up'
        | 'arrow-right'
        | 'arrow-left'
        | 'h-bar-3'
        | 'arrow-left-long'
        | 'greeting'
        | 'demographic'
        | 'eclipsis-h';
    width?: number;
}> = ({ type, width }) => {
    width = width || 12;
    if (type === 'arrow-left') {
        return (
            <svg
                className="icons icons-arrow"
                version="1.1"
                baseProfile="full"
                xmlns="http://www.w3.org/2000/svg"
                width={width}
                height={width}
                viewBox="0 0 40 40"
            >
                <polyline strokeLinejoin="miter" points="28,4 12,20 28,36" />
            </svg>
        );
    }
    if (type === 'arrow-right') {
        return (
            <svg
                className="icons icons-arrow"
                version="1.1"
                baseProfile="full"
                xmlns="http://www.w3.org/2000/svg"
                width={width}
                height={width}
                viewBox="0 0 40 40"
            >
                <polyline strokeLinejoin="miter" points="12,4 28,20 12,36" />
            </svg>
        );
    }
    if (type === 'arrow-up') {
        return (
            <svg
                className="icons icons-arrow"
                version="1.1"
                baseProfile="full"
                xmlns="http://www.w3.org/2000/svg"
                width={width}
                height={width}
                viewBox="0 0 40 40"
            >
                <polyline strokeLinejoin="miter" points="4,28 20,12 36,28" />
            </svg>
        );
    }
    if (type === 'arrow-down') {
        return (
            <svg
                className="icons icons-arrow"
                version="1.1"
                baseProfile="full"
                xmlns="http://www.w3.org/2000/svg"
                width={width}
                height={width}
                viewBox="0 0 40 40"
            >
                <polyline strokeLinejoin="miter" points="4,12 20,28 36,12" />
            </svg>
        );
    }
    if (type === 'h-bar-3') {
        return (
            <svg
                className="icons icon-h-bar"
                viewBox="0 0 40 40"
                width={width}
                height={width}
                stroke="#333"
            >
                <path d="M0 2 L40 2 M0 20 L20 20 L0 20 M40 20 L20 20 L40 20 M0 38 L40 38" />
            </svg>
        );
    }

    if (type === 'arrow-left-long') {
        return (
            <svg
                className="icons icons-left-arrow-long"
                viewBox="0 0 120 100"
                width={width}
                height={width}
            >
                <path
                    d="
                    M 20,50
                    l 100,0
                    M 20,50
                    l 30,28
                    M 20,50
                    l 30,-28"
                    strokeLinecap="round"
                />
            </svg>
        );
    }
    if (type === 'greeting') {
        return (
            <svg width={width} height={width}>
                <image
                    id="greeting-svg"
                    width={width}
                    height={width}
                    href={`${STATIC_STORAGE_URL}/img/svg/greeting_v2.svg`}
                />
            </svg>
        );
    }
    if (type === 'demographic') {
        return (
            <svg width={width} height={width}>
                <image
                    id="demographic-svg"
                    width={width}
                    height={width}
                    href={`${STATIC_STORAGE_URL}/img/svg/demographic_v2.svg`}
                />
            </svg>
        );
    }
    if (type === 'eclipsis-h') {
        return <span className="icons eclipsis-h"></span>;
    }
};

export default Icons;
